import React, { Component } from 'react';
import ProductsComponent from '../../_Componants/Products/Products';

class Products extends Component{
    render(){
        return (
            <div>
                <ProductsComponent/>
            </div>
        )
    }
}

export default Products;